export default __webpack_public_path__ + "static/media/plain-sticker-4.256066aa.png";